import apiClient from './api';

// Organisation setup: the franchise-arrangement register. Groups are read
// through the overview only — restaurantGroupsService owns group writes.
// Same envelope discipline as loyaltyService: unwrap {success, data} and
// throw the server's own sentence on failure.
const unwrap = ({ data }) => {
  if (!data?.success) throw new Error(data?.error || 'Request failed.');
  return data.data;
};
const fail = (err) => {
  throw new Error(err.response?.data?.error || err.message || 'Request failed.');
};
const get = (url) => apiClient.get(url).then(unwrap, fail);
const post = (url, body) => apiClient.post(url, body || {}).then(unwrap, fail);
const put = (url, body) => apiClient.put(url, body || {}).then(unwrap, fail);
const del = (url) => apiClient.delete(url).then(unwrap, fail);

const base = (rid) => `/users/restaurant/${rid}/organisation`;

const organisationService = {
  overview: (rid) => get(`${base(rid)}/`),
  createFranchise: (rid, body) => post(`${base(rid)}/franchises/`, body),
  saveFranchise: (rid, id, body) => put(`${base(rid)}/franchises/${id}/`, body),
  deleteFranchise: (rid, id) => del(`${base(rid)}/franchises/${id}/`),
};

export default organisationService;
